import SingleTeamRoute from './SingleTeamRoute';

export default SingleTeamRoute;
